// LightGallary.js
import React from "react";
import LightGallery from "lightgallery/react";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-fullscreen.css";
import "lightgallery/css/lg-rotate.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgFullscreen from "lightgallery/plugins/fullscreen";
import lgRotate from "lightgallery/plugins/rotate";

const LightGallary = ({ images, children }) => {
  return (
    // <LightGallery
    //   speed={500}
    //   plugins={[lgThumbnail, lgZoom, lgFullscreen, lgRotate]}
    //   mode="lg-fade"
    // >
    //   {images.map((img, index) => (
    //     <a key={index} href={img.src} data-sub-html={img.alt || ""}>
    //       <img
    //         src={img.thumb || img.src}
    //         alt={img.alt || `Image ${index + 1}`}
    //         style={{
    //           width: 150,
    //           height: 100,
    //           objectFit: "cover",
    //           marginRight: 10,
    //           borderRadius: 8,
    //           cursor: "pointer",
    //         }}
    //       />
    //     </a>
    //   ))}
    // </LightGallery>

    <LightGallery
      speed={500}
      plugins={[lgThumbnail, lgZoom, lgFullscreen, lgRotate]}
      // plugins={[lgThumbnail, lgFullscreen, lgRotate]}
      mode="lg-fade"
    >
      {children}
    </LightGallery>
  );
};

export default LightGallary;
